module.exports = __webpack_public_path__ + "img/machinebottom.26353e2f.png";